/* Orbit PDP – Galerie, Audio, Video, Variante, Sticky-/Abschluss-Button, zweisprachige Überschriften */
(function () {
  if (window.__orbitPdp) return;
  window.__orbitPdp = true;

  function initGallery(root) {
    root.querySelectorAll('.orbit-pdp [data-o-gal]').forEach(function (g) {
      if (g.dataset.ready) return;
      g.dataset.ready = '1';
      var slides = g.querySelectorAll('.main .s');
      var tbs = g.querySelectorAll('.tb');
      tbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
          tbs.forEach(function (b, j) { b.classList.toggle('is-active', j === i); });
        });
      });
    });
  }

  var cur = null, curBtn = null;
  function stopAudio() {
    if (cur) cur.pause();
    if (curBtn) curBtn.classList.remove('is-playing');
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.orbit-pdp [data-audio]');
    if (b) {
      e.preventDefault();
      var wrap = b.closest('[data-o-player]');
      var slow = wrap && wrap.querySelector('input[data-slow]:checked');
      var src = (slow && b.dataset.audioSlow) || b.dataset.audio;
      if (!src) return;
      if (curBtn === b && cur && !cur.paused) { stopAudio(); return; }
      stopAudio();
      cur = new Audio(src);
      curBtn = b;
      b.classList.add('is-playing');
      cur.play().catch(function () { b.classList.remove('is-playing'); });
      cur.onended = function () { b.classList.remove('is-playing'); };
      return;
    }

    var v = e.target.closest('.orbit-pdp [data-o-video]');
    if (v) {
      e.preventDefault();
      var vid = v.closest('.ph').querySelector('video');
      if (vid) { vid.controls = true; vid.play(); v.classList.add('hidden'); }
      return;
    }

    var p = e.target.closest('.orbit-pdp [data-o-proxy]');
    if (p) {
      var f = document.getElementById(p.dataset.oProxy);
      if (!f || p.form === f) return; /* kein Haupt-Formular: eigenes Formular sendet */
      e.preventDefault();
      var btn = f.querySelector('[type=submit]');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      if (f.requestSubmit) f.requestSubmit(btn); else btn.click();
    }
  });

  document.addEventListener('change', function (e) {
    var s = e.target.closest('.orbit-pdp select[data-o-variant]');
    if (!s) return;
    var o = s.options[s.selectedIndex];
    var ok = o.dataset.available === 'true';
    document.querySelectorAll('.orbit-pdp input[data-o-id]').forEach(function (i) { i.value = o.value; });
    document.querySelectorAll('.orbit-pdp [data-o-price]').forEach(function (el) { el.textContent = o.dataset.price; });
    ['1', '2', '3'].forEach(function (n) {
      document.querySelectorAll('.orbit-pdp [data-o-p' + n + ']').forEach(function (el) { el.textContent = o.dataset['p' + n]; });
    });
    document.querySelectorAll('.orbit-pdp [data-o-atc]').forEach(function (b) {
      b.disabled = !ok;
      var l = b.querySelector('span');
      if (l) l.textContent = ok ? b.dataset.label : b.dataset.soldout;
    });
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', o.value);
      window.history.replaceState({}, '', u.toString());
    } catch (err) {}
  });

  /* Der eine Moment: die albanische Zeile jeder Überschrift schreibt sich ein */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('o-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -12% 0px' }) : null;
  function initReveal(root) {
    if (!io || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var heads;
    try { heads = root.querySelectorAll('.orbit-pdp .head, .orbit-pdp div:has(> .eyebrow + h2)'); }
    catch (err) { heads = root.querySelectorAll('.orbit-pdp .head'); }
    heads.forEach(function (el) {
      if (el.dataset.oRv || !el.querySelector(':scope > .eyebrow')) return;
      el.dataset.oRv = '1';
      el.classList.add('o-rv');
      io.observe(el);
    });
  }

  function boot() { initGallery(document); initReveal(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initGallery(e.target); initReveal(e.target); });
})();
